import React, { FunctionComponent, memo } from 'react';
import useProfileMenu from './useProfileMenu';
import './ProfileMenu.scss';
import { Avatar, Menu, MenuTrigger, MenuItem, Tooltip } from '@web-components-proxy';
import { getClasses } from '@utils';
import { useModal, DiscardChangesModal } from '@shared-components';

const ProfileMenu: FunctionComponent = () => {
	const { isOpen, openModal, closeModal } = useModal();
	const {
		isMenuOpen,
		userData,
		menuRef,
		mpoeLink,
		mpoeRedirectionHandler,
		logOutHandler,
		checkIfSavedHandler,
	} = useProfileMenu(openModal);
	const { initials, photoUrl, displayName, email } = userData;

	return (
		<>
			<DiscardChangesModal
				isOpen={isOpen}
				cancelLabel="Stay"
				confirmLabel="Leave"
				closeCancelAction={closeModal}
				closeConfirmAction={logOutHandler}
				title="Unsaved changes"
				text="If you leave now, your current changes will be lost."
			/>

			<div className={getClasses({ profile: true, 'profile--active': isMenuOpen })} ref={menuRef}>
				<MenuTrigger trigger-for="profile-menu">
					<Avatar alt={displayName} size="M" text={initials} image-url={photoUrl}></Avatar>
					<Tooltip tooltipFor="profile-button" show-arrow="false">
						Profile
					</Tooltip>
				</MenuTrigger>
				<Menu id="profile-menu" x-position="after" y-position="below" class="profile__menu">
					<div className="profile__menuHeader" slot="menu-header">
						<div className="profile__userInfo">
							<div className="profile__userName">{displayName}</div>
							<div className="profile__userMail">{email}</div>
						</div>
					</div>
					{mpoeLink && <MenuItem onClick={mpoeRedirectionHandler}>Main Point of Entry</MenuItem>}
					<MenuItem onClick={checkIfSavedHandler}>Log Out</MenuItem>
				</Menu>
			</div>
		</>
	);
};
export default memo(ProfileMenu);
